import React, { useState } from 'react';
import { updateTicket } from '../../../api/tickets';
import MarkdownViewer from '../../common/MarkdownViewer';
import MarkdownEditor from '../../common/MarkdownEditor';

const TicketDescription = ({ ticketId, description, canEdit, onUpdate, onTicketClick }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState(description || '');

  const handleSave = async () => {
    const { data } = await updateTicket(ticketId, { description: value });
    if (data) {
      onUpdate(data.description);
    }
    setEditing(false);
  };

  const handleCancel = () => {
    setValue(description || '');
    setEditing(false);
  };

  if (editing && canEdit) {
    return (
      <div className="ticket-description editing">
        <MarkdownEditor
          value={value}
          onChange={setValue}
          height="300px"
          placeholder="輸入說明（支援 Markdown）..."
        />
        <div className="description-actions">
          <button className="btn-save" onClick={handleSave}>儲存</button>
          <button className="btn-cancel" onClick={handleCancel}>取消</button>
        </div>
      </div>
    );
  }

  return (
    <div className="ticket-description">
      <div className="description-header">
        <h3>說明</h3>
        {canEdit && (
          <button className="edit-btn" onClick={() => setEditing(true)} title="編輯說明">
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M10 1.5l2.5 2.5M1 13l.8-3.2L10.3 1.3a1 1 0 011.4 0l1 1a1 1 0 010 1.4L4.2 12.2 1 13z" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
      </div>
      {description ? (
        <MarkdownViewer content={description} onTicketClick={onTicketClick} />
      ) : (
        <p className="no-description">
          {canEdit ? '點擊右上角編輯新增說明' : '尚無說明'}
        </p>
      )}
    </div>
  );
};

export default TicketDescription;
